import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "leading-5"
};
const _hoisted_2 = {
  key: 0,
  class: "text-stone-500 font-normal"
};
const _hoisted_3 = {
  class: "flex flex-col -mx-3"
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 1,
  class: "flex items-center"
};
const _hoisted_6 = {
  key: 1,
  class: "bg-slate-100 py-1 px-3 rounded uppercase"
};
import Modal from "@/modules/vue/components/Modal.vue";
import { NegotiationStatusEnum } from "@/modules/diplomacy/enums";
import NegotiationFields from "@/modules/diplomacy/components/NegotiationFields.vue";
import Talent from "@/modules/youth/components/Talent.vue";
import { app } from "@/di";
import { YouthPlayerNegotiationStarter } from "@/modules/youth/services/YouthPlayerNegotiationStarter";
import { Team } from "@/modules/team/entity";
import Flag from "@/modules/vue/components/Flag.vue";
import EntityLink from "@/modules/vue/components/EntityLink.vue";
import FormGroup from "@/modules/vue/components/FormGroup.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'YouthPlayerModal',
  props: {
    entity: null
  },
  setup(__props, {
    expose
  }) {
    const props = __props;
    const modal = ref();
    const negotiation = ref();
    const canNegotiate = ref(false);
    const router = useRouter();
    const negotiate = async () => {
      const negotiation = await app.get(YouthPlayerNegotiationStarter).start(await Team.current(), props.entity);
      await router.push({
        name: 'negotiations.show',
        params: {
          id: negotiation.id
        }
      });
    };
    const hide = () => modal.value.hide();
    const show = async () => {
      await props.entity.load(['team', 'negotiations', 'recruitedBy']);
      for (const n of props.entity.negotiations) {
        await n.load('team');
        if (n.team.isCurrent) {
          negotiation.value = n;
        }
      }
      canNegotiate.value = await app.get(YouthPlayerNegotiationStarter).canNegotiation(props.entity.team, props.entity);
      modal.value.show();
    };
    const onClickNegotiation = () => {
      hide();
      router.push({
        name: 'negotiations.show',
        params: negotiation.value
      });
    };
    expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(Modal, {
        ref_key: "modal",
        ref: modal
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('youth_player')), 1), __props.entity ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.entity.name), 1)) : _createCommentVNode("", true)])]),
        footer: _withCtx(() => [negotiation.value ? (_openBlock(), _createBlock(_component_NButton, {
          key: 0,
          type: negotiation.value.status === _unref(NegotiationStatusEnum).OPENED ? 'success' : 'primary',
          onClick: onClickNegotiation
        }, {
          default: _withCtx(() => [_createVNode(_component_Icon, {
            icon: _ctx.IconEnum.Handshake20Regular
          }, null, 8, ["icon"])]),
          _: 1
        }, 8, ["type"])) : _createCommentVNode("", true), canNegotiate.value ? (_openBlock(), _createBlock(_component_NButton, {
          key: 1,
          secondary: "",
          type: "primary",
          onClick: _withModifiers(negotiate, ["stop"])
        }, {
          default: _withCtx(() => [_createVNode(_component_Icon, {
            icon: _ctx.IconEnum.Handshake20Regular
          }, null, 8, ["icon"])]),
          _: 1
        }, 8, ["onClick"])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(FormGroup, {
          label: _ctx.$t('recruited_by')
        }, {
          default: _withCtx(() => [__props.entity.recruitedBy ? (_openBlock(), _createBlock(EntityLink, {
            key: 0,
            entity: __props.entity.recruitedBy
          }, null, 8, ["entity"])) : (_openBlock(), _createElementBlock("span", _hoisted_4, "--"))]),
          _: 1
        }, 8, ["label"]), _createVNode(FormGroup, {
          label: _ctx.$t('name'),
          readonly: ""
        }, {
          default: _withCtx(() => [!__props.entity.canSee('name') ? (_openBlock(), _createBlock(_component_Icon, {
            key: 0,
            icon: _ctx.IconEnum.QuestionCircle32Regular
          }, null, 8, ["icon"])) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode(_toDisplayString(__props.entity.name), 1)], 64))]),
          _: 1
        }, 8, ["label"]), _createVNode(FormGroup, {
          label: _ctx.$t('country'),
          readonly: ""
        }, {
          default: _withCtx(() => [!__props.entity.canSee('country') ? (_openBlock(), _createBlock(_component_Icon, {
            key: 0,
            icon: _ctx.IconEnum.QuestionCircle32Regular
          }, null, 8, ["icon"])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(Flag, {
            country: __props.entity.country,
            class: "mr-1"
          }, null, 8, ["country"]), _createTextVNode(" " + _toDisplayString(__props.entity.country.name), 1)]))]),
          _: 1
        }, 8, ["label"]), _createVNode(FormGroup, {
          label: _ctx.$t('age'),
          readonly: ""
        }, {
          default: _withCtx(() => [!__props.entity.canSee('age') ? (_openBlock(), _createBlock(_component_Icon, {
            key: 0,
            icon: _ctx.IconEnum.QuestionCircle32Regular
          }, null, 8, ["icon"])) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode(_toDisplayString(__props.entity.age), 1)], 64))]),
          _: 1
        }, 8, ["label"]), _createVNode(FormGroup, {
          label: _ctx.$t('position'),
          readonly: ""
        }, {
          default: _withCtx(() => [!__props.entity.canSee('position') ? (_openBlock(), _createBlock(_component_Icon, {
            key: 0,
            icon: _ctx.IconEnum.QuestionCircle32Regular
          }, null, 8, ["icon"])) : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.entity.position), 1))]),
          _: 1
        }, 8, ["label"]), _createVNode(FormGroup, {
          label: _ctx.$t('talent'),
          readonly: ""
        }, {
          default: _withCtx(() => [!__props.entity.canSee('talent') ? (_openBlock(), _createBlock(_component_Icon, {
            key: 0,
            icon: _ctx.IconEnum.QuestionCircle32Regular
          }, null, 8, ["icon"])) : (_openBlock(), _createBlock(Talent, {
            key: 1,
            talent: __props.entity.talent
          }, null, 8, ["talent"]))]),
          _: 1
        }, 8, ["label"]), _createVNode(FormGroup, {
          label: _ctx.$t('skill'),
          readonly: ""
        }, {
          default: _withCtx(() => [!__props.entity.canSee('skill') ? (_openBlock(), _createBlock(_component_Icon, {
            key: 0,
            icon: _ctx.IconEnum.QuestionCircle32Regular
          }, null, 8, ["icon"])) : (_openBlock(), _createBlock(Talent, {
            key: 1,
            talent: __props.entity.skill
          }, null, 8, ["talent"]))]),
          _: 1
        }, 8, ["label"]), _createVNode(NegotiationFields, {
          entity: __props.entity
        }, null, 8, ["entity"])])]),
        _: 1
      }, 512);
    };
  }
});